/**********   Admin Profile types ****************/
const IS_LOGIN = 'is_login';

/**************************************************** */

/**********************************************Tests types */
const GET_TESTS = 'get_tests';
const GET_NEXT_TESTS = 'get_next_tests';
const GET_PREV_TESTS = 'get_prev_tests';
const SAVE_COC_TYPES = 'save_coc_types';
const ADD_COC_TYPE = 'add_coc_type';
const UPDATE_COC_TYPE = 'update_coc_type';
const DELETE_COC_TYPE = 'delete_coc_type';
const ADD_NEW_TEST = 'add_new_test';
const REMOVE_TEST = 'remove_test';

/**************************************************** */

/**********************************Labs types********************************** */
const STORE_CONDUCTED_TESTS = 'store_conducted_tests';
const STORE_LABS = 'store_labs';
const UPDATE_TOTAL_COUNT = 'update_total_count'
const SET_COC_LIST = 'set_coc_list';
const UPDATE_LAB_PAYS = 'update_lab_pays';
const APPROVE_LAB = 'approve_lab';
const DELETE_LAB = 'delete_lab';
/**************************************************** */

/**********************************Categories Types ********************************** */
const GET_CATEGORIES = 'get_categories';
const GET_NEXT_CATEGORIES = 'get_next_categories';
const GET_PREV_CATEGORIES = 'get_prev_categories';
const UPDATE_CATEGORY_STATUS = 'update_category_status';
const ADD_NEW_CATEGORY = 'add_new_category';
const GET_ACTIVE_CATEGORIES = 'get_active_categories';
const UPDATE_CATEGORY_NAME = 'UPDATE_CATEGORY_NAME';
const UPDATE_ANALYSIS_TYPE_NAME = 'UPDATE_ANALYSIS_TYPE_NAME';
/**************************************************** */

/**********************************Users / Billing Types ********************************** */
const STORE_USERS = 'store_users';
const STORE_USER_BILLING_MAP = 'store_user_billing_map';
const UPDATE_USER_BILLING_ENTRY = 'update_user_billing_entry';
const REMOVE_USER = 'remove_user';
const STORE_COMPANY_DETAILS_MAP = 'store_company_details_map';

/**********************************Payments Types ********************************** */
const STORE_PAYMENTS = 'store_payments';

/**********************************Inquiries Types ********************************** */
const STORE_INQUIRIES = 'store_inquiries';
const UPDATE_INQUIRY_STATUS = 'update_inquiry_status';

export {
  GET_TESTS,
  GET_NEXT_TESTS,
  GET_PREV_TESTS,
  IS_LOGIN,
  GET_CATEGORIES,
  GET_NEXT_CATEGORIES,
  GET_PREV_CATEGORIES,
  UPDATE_CATEGORY_STATUS,
  ADD_NEW_CATEGORY,
  GET_ACTIVE_CATEGORIES,
  SAVE_COC_TYPES,
  ADD_COC_TYPE,
  UPDATE_COC_TYPE,
  DELETE_COC_TYPE,
  ADD_NEW_TEST,
  REMOVE_TEST,
  STORE_CONDUCTED_TESTS,
  STORE_LABS,
  UPDATE_CATEGORY_NAME,
  UPDATE_ANALYSIS_TYPE_NAME,
  UPDATE_TOTAL_COUNT,
  SET_COC_LIST,
  UPDATE_LAB_PAYS,
  APPROVE_LAB,
  DELETE_LAB,
  STORE_USERS,
  STORE_USER_BILLING_MAP,
  UPDATE_USER_BILLING_ENTRY,
  REMOVE_USER,
  STORE_COMPANY_DETAILS_MAP,
  STORE_PAYMENTS,
  STORE_INQUIRIES,
  UPDATE_INQUIRY_STATUS,
}

